import axios from 'axios';
import React from 'react'

export default function Message() {

    const sendMessage = async () => {
        try {
            const response = await axios.post('https://klimkaara-backend-pgnq.onrender.com/admins/sendmessage');
        } catch (error) {
            console.error(error.response.data);
        }
    };

  return (
    <div className='container mx-auto min-h-screen'>
      <button type="button" className="bg-[#fded22] py-2 text-black px-4 rounded-full font-semibold hover:bg-white" onClick={sendMessage}>Send</button>
    </div>
  )
}
